import React, { Component } from 'react';  
import Util from "../../util.js";
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import { clearJyOne } from "../../action/investmentAction.js";
import { connect } from 'react-redux';

class EducationCalculatorSelectSchool extends Component { 
  state = {
    theMoney: "",
    childAge: 0
  } 

  componentWillMount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "进入"]);
    document.getElementsByTagName('title')[0].innerHTML = "教育智能规划";
  }

  componentWillUnmount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "退出"]);
  }

  goBack = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "回退"]);
    hashHistory.goBack();
  }

  goEducationCalculator = (school) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "选择学校"]);
    let { dispatch } = this.props;
    hashHistory.push({
      pathname: "/educationCalculator",
      state: {
        school: school
      }
    });
    dispatch(clearJyOne(school));
  }

  render() { 
    let { theMoney, childAge } = this.state;
    return (  
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader bgChange">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>教育智能规划</span>
            </div>
            <div>
              
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div  className="bgChange2" style={{backgroundSize: "cover",width: window.winWidth, height: "auto", paddingBottom: 20, paddingTop: 20}}>
            <div style={{
              width: window.winWidth,
              paddingLeft: 13,
              paddingRight: 13,
              WebkitFlexDirection: "row",
              WebkitJustifyContent: "space-between",
              WebkitAlignItems: "center",
              display: "-webkit-flex"
            }}>
              <img
              style={{width: 63, height: 63}}
              src={require("../../img/jqrIcon.png")}
              />
              <div style={{paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth-96, borderRadius: 10}}>
                <span style={{
                  color: "#fff",
                  lineHeight: "16px",
                  fontSize: 13
                }}>投资教育的方式不是只有学区房，与其买一套80年代的天价学区房，还不如让查理为您量身定制一份教育理财规划方案，为孩子上学提前储备教育金。</span>
              </div> 
            </div>
          </div>
          <div style={{paddingTop: 25, paddingLeft: 13, paddingRight: 13, paddingBottom: 12.5}}>
            <span style={{color: "#5b6270", fontSize: "13px"}}>请选择您的教育储备金使用阶段:</span>
          </div>
          <div style={{height: 240, backgroundColor: "#fff", paddingLeft: 13, paddingRight: 13}}>
            <div style={{display: "-webkit-flex", height: 80, borderBottom: "1px solid rgb(235, 238, 240)", WebkitFlexDirection: "row"}} onClick={() => this.goEducationCalculator("大学")}>
              <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", marginRight: 15}}>
                <img 
                src={require("../../img/daxueIcon.png")}
                style={{height: 48, width: 48}}
                />
              </div>
              <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitFlexDirection: "column"}}>
                <div style={{marginBottom: 7.5}}>
                  <span style={{fontSize: "13px", color: "#3a3e47", display: "block"}}>常青藤大学组合</span>
                </div>
                <div>
                  <span style={{fontSize: 10, color: "#a1a7b2", display: "block"}}>为大学阶段储备教育金</span>
                </div>
              </div>
            </div>
            <div style={{display: "-webkit-flex", height: 80, borderBottom: "1px solid rgb(235, 238, 240)", WebkitFlexDirection: "row"}} onClick={() => this.goEducationCalculator("高中")}>
              <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", marginRight: 15}}>
                <img 
                src={require("../../img/gaozhongIcon.png")}
                style={{height: 48, width: 48}}
                />
              </div>
              <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitFlexDirection: "column"}}>
                <div style={{marginBottom: 7.5}}>
                  <span style={{fontSize: "13px", color: "#3a3e47", display: "block"}}>菁英高中生组合</span>
                </div>
                <div>
                  <span style={{fontSize: 10, color: "#a1a7b2", display: "block"}}>为高中阶段储备教育金</span>
                </div>
              </div>
            </div>
            <div style={{display: "-webkit-flex", height: 80, WebkitFlexDirection: "row"}} onClick={() => this.goEducationCalculator("初中")}>
              <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", marginRight: 15}}>
                <img 
                src={require("../../img/xiaoxueIcon.png")}
                style={{height: 48, width: 48}}
                />
              </div>
              <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitFlexDirection: "column"}}>
                <div style={{marginBottom: 7.5}}>
                  <span style={{fontSize: "13px", color: "#3a3e47", display: "block"}}>雏鹰初中生组合</span>
                </div>
                <div>
                  <span style={{fontSize: 10, color: "#a1a7b2", display: "block"}}>为初中阶段储备教育金</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    );  
  }  
}  

function mapStateToProps(state, ownProps) {
  return {
     
  }
}
  
export default connect(mapStateToProps)(EducationCalculatorSelectSchool);


// WEBPACK FOOTER //
// ./src/components/recommend/EducationCalculatorSelectSchool.js